export default __webpack_public_path__ + "e68386b33c6f7f55c273b6bace403cf6.png";